import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import fetchKamData from "../Services/fetchKamData";
import useCurrentMasterCountry from "views/Components/Shared/hooks/useCurrentMasterCountry";

export default function useProductMasterKamQuery() {
  const { accessToken } = useAuth();
  const mainCountry = useCurrentMasterCountry();
  const mainCountryId = mainCountry?.id;

  const productMasterKamQuery = useQuery({
    queryKey: ["productMasterKam", mainCountryId],
    queryFn: () => fetchKamData({ accessToken, mainCountry }),
    enabled: !!mainCountryId,
    staleTime: Infinity,
    retry: false,
  });

  return productMasterKamQuery;
}
